import { AfterViewInit, Directive, ElementRef, OnDestroy, output } from '@angular/core';


@Directive({
  selector: '[appWidgetHeight]',
  standalone: false
})
export class WidgetHeightDirective implements AfterViewInit, OnDestroy {
  public readonly appWidgetHeightChange = output<number>();

  private readonly resizeObserver = new ResizeObserver(([entry]) => {
    this.appWidgetHeightChange.emit(entry.contentRect.height);
  });

  constructor(private readonly elementRef: ElementRef<HTMLElement>) { }

  public ngAfterViewInit(): void {
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  public ngOnDestroy(): void {
    this.resizeObserver.disconnect();
  }
}
